import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getSessionItem } from "../helpers/function.helper";

const ProtectedRoute: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await getSessionItem("sessionToken");
        setIsAuthenticated(!!token);
      } catch (err) {
        console.error("Error reading session:", err);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    // 🌀 Show a small loader while checking session
    return (
      <div className="h-screen flex items-center justify-center text-gray-600">
        Checking session...
      </div>
    );
  }

  if (!isAuthenticated) {
    // ⛔ Redirect to login if no token
    return <Navigate to="/admin/login" replace />;
  }

  // ✅ Authenticated → render nested route
  return <Outlet />;
};

export default ProtectedRoute;
